module.exports = __webpack_public_path__ + "static/media/question_guya.3cd68edb.svg";